import React, { useState, useRef, useEffect } from "react";
import "./scss/search-select.scss";

export default function SearchSelect({
  label,
  value,
  onChange,
  options = [],
  recent = [],
  placeholder = "",
  className = ""
}) {
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState(value || "");
  const wrapperRef = useRef(null);

  const isActive = open || inputValue.length > 0;

  const filteredOptions =
    inputValue.length > 0
      ? options.filter(o =>
          o.toLowerCase().includes(inputValue.toLowerCase())
        )
      : recent.slice(0, 10);

  useEffect(() => {
    function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (val) => {
    setInputValue(val);
    onChange?.(val);
    setOpen(false);
  };

  const clear = () => {
    setInputValue("");
    onChange?.("");
  };

  return (
    <div
      className={`search-select ${className} ${isActive ? "active" : ""}`}
      ref={wrapperRef}
    >
      <div className="search-select__input-wrapper">
        <input
          value={inputValue}
          placeholder={placeholder}
          onFocus={() => setOpen(true)}
          onChange={e => {
            setInputValue(e.target.value);
            setOpen(true);
          }}
        />

        <label>{label}</label>

        {inputValue && (
          <button
            type="button"
            className="search-select__clear"
            onClick={clear}
          >
            ×
          </button>
        )}

        <button
          type="button"
          className={`search-select__arrow ${open ? "open" : ""}`}
          onClick={() => setOpen(!open)}
        >
          ⌃
        </button>
      </div>

      {open && filteredOptions.length > 0 && (
        <div className="search-select__dropdown">
          {filteredOptions.map((option, idx) => (
            <div
              key={idx}
              className="search-select__option"
              onClick={() => handleSelect(option)}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
